/**
 * =================
 * PANE
 * navigation
 * =================
 */
app.pane = (function(module) {

  // staff
  var $win = app.$(window),
      $pane;

  module.init = function() {
    $pane = app.$('.navigation-pane');

    if (!$pane.length) return;

    _bindingPaneEvents();
  };

	// fn's
  function _bindingPaneEvents() {
		$win.on(app.navigation.getEvents()[1], _closePane);

		app.$(document)
      .on('click', '.navigation-pane-button', _onOpenButton)
      .on('click', '.pane-close-button',      _onCloseButton);

    $pane.on('click', '.lnk[href^="#pane-submenu"]', _openSubmenu);
	}

  // auxiliary
  function _openSubmenu(e) {
    e.preventDefault();
    app.$(this).siblings('.pane-submenu').toggleClass('active');
  }

	function _onOpenButton(e) {
		e.preventDefault();
				
		if ($pane.is('.active')) {
			_closePane();
			$win.trigger(app.navigation.getEvents()[1]);
			
			return;
		}

		$win.trigger(app.navigation.getEvents()[0]);
		_openPane();		
	}

	function _onCloseButton(e) {
		$win.trigger(app.navigation.getEvents()[1]);
    _closePane();		
	}

  function _openPane() {
		$pane.addClass('active');
		_activateButton(app.$('.navigation-pane-button').add('.pane-close-button'));
  }

  function _closePane() {
		_deactivateButton(app.$('.pane-close-button').add('.navigation-pane-button'));
		$pane.removeClass('active');
	}

	function _activateButton($button) {
		$button.addClass('active');
	}

	function _deactivateButton($button) {
		$button.removeClass('active');
	}

  // kickstart!
  app.$(function() {
    module.init();
  });

  return module;

}(app.pane || {}));


/* EOF */